/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-target-blank */
import {
  CameraOutlined,
  LoadingOutlined,
  PushpinFilled,
  PushpinOutlined,
} from '@ant-design/icons';
import ClassNames from 'classnames';
import moment from 'moment';
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import ReactPlayer from 'react-player';
import DurationComponent from './Duration';
import CenterControlIcon from './icons/center_ovif.svg';
import ControlIconOff from './icons/control_camera_off.svg';
import ControlIconOn from './icons/control_camera_on.svg';
import DownloadIcon from './icons/download.svg';
import FullscreenIcon from './icons/fullscreen.svg';
import ExitFullscreenIcon from './icons/fullscreen_exit.svg';
import StreamIcon from './icons/live_stream.svg';
import MoveIconOff from './icons/move_camera_off.svg';
import MoveIconOn from './icons/move_camera_on.svg';
import PauseIcon from './icons/pause.svg';
import PlayArrowIcon from './icons/play_arrow.svg';
import ResetIcon from './icons/refresh.svg';
import ReplayIcon from './icons/replay.svg';
import './index.scss';

import ArrowLeftOffIcon from './icons/arrow_back_off.svg';
import ArrowLeftOnIcon from './icons/arrow_back_on.svg';
import ArrowRightOffIcon from './icons/arrow_forward_off.svg';
import ArrowRightOnIcon from './icons/arrow_forward_on.svg';
import ArrowTopOffIcon from './icons/arrow_upward_off.svg';
import ArrowTopOnIcon from './icons/arrow_upward_on.svg';
import ArrowBottomOffIcon from './icons/arrow_downward_off.svg';
import ArrowBottomOnIcon from './icons/arrow_downward_on.svg';
import ZoomInOffIcon from './icons/zoom_in_off.svg';
import ZoomInOnIcon from './icons/zoom_in_on.svg';
import ZoomOutOffIcon from './icons/zoom_out_off.svg';
import ZoomOutOnIcon from './icons/zoom_out_on.svg';

import { useDispatch, useSelector } from 'react-redux';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { removeStream, setPinnedCamerasMode } from '../../redux/actions';
import { calcPercentForVideo } from '../../untils/css';
import { downloadFile } from '../../untils/download';
import SpinnerComponent from './Spinner';
import usePanAndZoomVideo from './usePanAndZoomVideo';
import { StreamConnectStep } from './StreamConnectStep';
import { beeXLogger } from '../../helpers/logger';
import { isStreamNotFoundError } from '../VideoStream/utils';
import { detectMediaCodec } from '../../utils/mediaCodecDetector';
import {
  HLSThroughputTracker,
  WebRTCThroughputTracker,
} from '../../utils/streamThroughputTracker';

const speeds = [
  { value: 0.1, title: '0.1x' },
  { value: 0.5, title: '0.5x' },
  { value: 1, title: '1x' },
  { value: 2, title: '2x' },
  { value: 4, title: '4x' },
  { value: 8, title: '8x' },
  { value: 16, title: '16x' },
];

const StreamOptions = {
  webrtc: 'Ultra Fast',
  hls: 'Fast',
};

const HLS_RETRY_MAX = 3;
const HLS_RETRY_DELAY = 5000;

const HLS_PLAYER_REMOUNT_RETRY_MAX = 2;
const HLS_PLAYER_REMOUNT_RETRY_TIMEOUT = 10000;

const STABLE_PLAY_THRESHOLD = 15000;

const PlayerComponent = ({
  type,
  src,
  name,
  sourceObject,
  poster,
  loading,
  status,
  onvif,
  onRotate,
  onZoom,
  fullScreenCallBack,
  restartCallBack,
  restartLoadingCallBack,
  setOnPlay,
  zoomStateProps,
  isFullscreenProps,
  permission,
  serial,
  checkTransferZoomState,
  zoomStatePlayer,
  setZoomStatePlayer,
  restartQualityCallBack,
  logContent,
  logSerial,
  handleReportActionLog,
  dateTime,
  isHlsStreaming,
  seekTo,
  allScreen,
  protocol,
  setRefVideo,
  onPlay,
  onError,
  modes = [],
  selectedMode,
  streamData = null,
  streamConnectStep = null,
  setStreamConnectStep = () => { },
  streamConnectStepStates = null,
  streamConnectError = null,
  streamConnectErrorStep = null,
  streamConnectIsSuccess = null,
  gridMode,
  onFullscreenChange,
  streamMonitorId,
  onHlsRemountingChange,
  onStreamNotFound,
  codec,
  subSources,
  adapter = null,
}) => {
  let RETRY_TIMES = 3;
  let RETRY_DURATION = 5000;
  const progress = useRef();
  const refVideo = useRef();
  const refVideoTotal = useRef();
  const refInterval = useRef();
  const dispatch = useDispatch();
  const { pinnedCamerasMode, dataUser, streams } = useSelector(
    (state) => state,
  );
  const [count, setCount] = useState(1);
  const [rotatable, setRotatable] = useState(false);
  const [rotate, setRotate] = useState();
  const [zooming, setZooming] = useState();
  const [pin, setPin] = useState([]);
  const [isPinAll, setIsPinAll] = useState(false);
  const canvasRef = useRef();
  const [dimensions, setDimensions] = useState({});
  const [videoKey, setVideoKey] = useState();
  const [playedSecs, setPlayedSecs] = useState(0);
  const [key, setKey] = useState(Math.floor(Math.random() * 1000));
  const [modeLive, setModeLive] = useState();
  const [countHls, setCountHls] = useState(0);
  const [isRestartHls, setIsRestartHls] = useState(false);
  const hlsRetryEndTimeoutRef = useRef(null);
  const hlsReconnectTimeoutRef = useRef(null);
  const hlsRetryCountRef = useRef(0);
  const [isDownloading, setIsDownloading] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(1);
  const retryInterval = useRef(null);
  const { width: windowWidth, height: windowHeight } = useWindowDimensions();
  const [isFullScreen, setIsFullscreen] = useState(false);
  const stablePlayTimerRef = useRef(null);

  useEffect(() => {
    return () => {
      dispatch(removeStream(serial));
    };
  }, [serial]);

  const [video, setVideo] = useState({
    controls: false,
    src: null,
    type: 'video',
    loading: true,
    playbackRate: 1.0,
    url: null,
    playing: false,
    volume: 0.5,
    muted: false,
    played: 0,
    duration: 0,
    ended: false,
    seeking: false,
    fullscreen: false,
  });

  const [videoError, setVideoError] = useState();
  const [zoomStateOption, setZoomStateOption] = useState();
  const [detectedPlaybackCodec, setDetectedPlaybackCodec] = useState(null);

  useEffect(() => {
    if (type === 'video' && src) {
      detectMediaCodec(src).then((res) => {
        if (res && res.codec && res.codec !== 'UNKNOWN') {
          setDetectedPlaybackCodec(res.codec);
        }
      });
    }
  }, [type, src]);

  const currentCodec = useMemo(() => {
    if (detectedPlaybackCodec) {
      return detectedPlaybackCodec;
    }

    const currentZoom = zoomStatePlayer?.zoomState;
    const matchedZoomState = zoomStatePlayer?.dataZoomStates?.find(
      (item) => item?.zoomState === currentZoom,
    );

    if (matchedZoomState?.codec) {
      return matchedZoomState.codec;
    }

    if (zoomStatePlayer?.codec) {
      return zoomStatePlayer.codec;
    }

    if (subSources && currentZoom) {
      try {
        const parsed =
          typeof subSources === 'string' ? JSON.parse(subSources) : subSources;
        if (Array.isArray(parsed) && parsed.length > 0) {
          const matchedSub = parsed.find(
            (item) => item.zoomState === currentZoom,
          );
          if (matchedSub?.codec) {
            return matchedSub.codec;
          }
        }
      } catch (e) {
        // ignore
      }
    }

    return null;
  }, [
    detectedPlaybackCodec,
    zoomStatePlayer?.codec,
    zoomStatePlayer?.dataZoomStates,
    zoomStatePlayer?.zoomState,
    subSources,
  ]);

  const hlsTrackerRef = useRef(new HLSThroughputTracker(6000));
  const webrtcTrackerRef = useRef(new WebRTCThroughputTracker());
  const [throughputText, setThroughputText] = useState('');

  useEffect(() => {
    setThroughputText('');
    hlsTrackerRef.current.reset();
    webrtcTrackerRef.current.stop();
  }, [sourceObject?.link, serial, selectedMode, isHlsStreaming]);

  useEffect(() => {
    return () => {
      hlsTrackerRef.current.destroy();
      webrtcTrackerRef.current.destroy();
    };
  }, []);

  useEffect(() => {
    if (isHlsStreaming) {
      webrtcTrackerRef.current.stop();
      return;
    }

    let checkInterval = null;
    const tryStartWebRtcTracking = () => {
      const pc = adapter?.peerConnection;
      if (pc && pc.connectionState !== 'closed' && pc.signalingState !== 'closed') {
        webrtcTrackerRef.current.start(pc, (stats) => {
          if (stats?.throughput?.formatted) {
            setThroughputText(stats.throughput.formatted);
          }
        });
        if (checkInterval) {
          clearInterval(checkInterval);
          checkInterval = null;
        }
      }
    };

    tryStartWebRtcTracking();
    if (!adapter?.peerConnection) {
      checkInterval = setInterval(tryStartWebRtcTracking, 500);
    }

    return () => {
      if (checkInterval) clearInterval(checkInterval);
      webrtcTrackerRef.current.stop();
    };
  }, [adapter, adapter?.peerConnection, isHlsStreaming, selectedMode]);

  const clearHlsRetryTimers = useCallback(() => {
    if (hlsRetryEndTimeoutRef.current) {
      clearTimeout(hlsRetryEndTimeoutRef.current);
      hlsRetryEndTimeoutRef.current = null;
    }

    if (hlsReconnectTimeoutRef.current) {
      clearTimeout(hlsReconnectTimeoutRef.current);
      hlsReconnectTimeoutRef.current = null;
    }
  }, []);

  useEffect(() => {
    hlsRetryCountRef.current = countHls;
  }, [countHls]);

  useEffect(() => {
    return () => {
      clearHlsRetryTimers();
    };
  }, [clearHlsRetryTimers]);

  useEffect(() => {
    return () => {
      if (stablePlayTimerRef.current) {
        clearTimeout(stablePlayTimerRef.current);
        stablePlayTimerRef.current = null;
      }
    };
  }, []);

  const {
    containerRef,
    onMouseDown,
    onWheel,
    onReset,
    translateX,
    translateY,
    scale,
  } = usePanAndZoomVideo({ zoomable: video.controls });

  const [containerHeight, setContainerHeight] = useState('100%');

  let context;
  if (canvasRef.current) {
    context = canvasRef.current.getContext('2d');
  }

  function getVideoSizeData(videoRef) {
    const ratio = videoRef.current.videoWidth / videoRef.current.videoHeight;
    const w = videoRef.current.videoWidth;
    const h = parseInt(w / ratio, 10);
    return { ratio, w, h };
  }

  useEffect(() => {
    if (containerRef?.current?.clientWidth) {
      setContainerHeight(
        `${((containerRef.current.clientWidth * 9) / 16).toFixed(4)}px`,
      );
    }
  }, [containerRef?.current?.clientWidth]);

  useEffect(() => {
    if (type === 'streaming') {
      let refCurrentTime;
      if (!videoKey) {
        refCurrentTime = setInterval(() => {
          setVideoKey(Math.random());
        }, 1000);
      }
      return () => {
        clearInterval(refCurrentTime);
      };
    }
  }, []);

  useEffect(() => {
    if (refVideo?.current) {
      refVideo.current.addEventListener('loadedmetadata', function () {
        if (refVideo?.current) {
          const { w, h } = getVideoSizeData(refVideo);
          if (canvasRef?.current) {
            canvasRef.current.width = w;
            canvasRef.current.height = h;
          }
          setDimensions({ w, h });
        }
      });
    }
  }, []);

  const onDownloadDirectClick = () => {
    if (context && refVideo?.current) {
      context.fillRect(0, 0, dimensions.w, dimensions.h);
      context.drawImage(refVideo.current, 0, 0, dimensions.w, dimensions.h);

      const url = canvasRef.current.toDataURL('image/png');
      const link = document.createElement('a');
      link.download = `${serial ?? logSerial}_${dateTime ?? moment().format('DD-MM-YYYY')
        }.png`;
      link.href = url;
      link.click();
    }
  };

  useEffect(() => {
    setRotatable(type === 'streaming' && onvif);
  }, [onvif, type]);

  useEffect(() => {
    setPin(sessionStorage.getItem('pinCamera')?.split(',') || []);
    const pinCameraStorage = localStorage.getItem('pin_camera');
    if (pinCameraStorage) {
      setIsPinAll(JSON.parse(pinCameraStorage));
    }
  }, []);


  useEffect(() => {
    let refClear;
    if (rotate) {
      refClear = setTimeout(() => {
        setRotate(undefined);
      }, 500);
    }
    return () => {
      clearInterval(refClear);
    };
  }, [rotate]);

  useEffect(() => {
    let refClear;
    if (zooming) {
      refClear = setTimeout(() => {
        setZooming(undefined);
      }, 500);
    }
    return () => {
      clearInterval(refClear);
    };
  }, [zooming]);

  const onResetStream = useCallback(
    (dataObject) => {
      clearHlsRetryTimers();
      hlsRetryCountRef.current = 0;
      setVideo((state) => ({
        ...state,
        src: null,
        loading: true,
        playing: false,
        url: null,
      }));
      setPlayedSecs(0);
      setCountHls(0);
      setIsRestartHls(false);
      restartCallBack({ qualityLevel: dataObject?.qualityLevel });
    },
    [clearHlsRetryTimers, restartCallBack],
  );

  const onResetStreamLoading = useCallback(
    (dataObject) => {
      clearHlsRetryTimers();
      hlsRetryCountRef.current = 0;
      setVideo((state) => ({
        ...state,
        src: null,
        loading: true,
        playing: false,
        url: null,
      }));
      setPlayedSecs(0);
      setCountHls(0);
      setIsRestartHls(false);
      restartLoadingCallBack({ qualityLevel: dataObject?.qualityLevel });
    },
    [clearHlsRetryTimers, restartLoadingCallBack],
  );

  const onResetQualityStream = useCallback(
    (dataObject) => {
      clearHlsRetryTimers();
      hlsRetryCountRef.current = 0;
      setVideo((state) => ({
        ...state,
        src: null,
        loading: true,
        playing: false,
        url: null,
      }));
      setPlayedSecs(0);
      setCountHls(0);
      setIsRestartHls(false);
      if (setZoomStatePlayer && dataObject?.qualityLevel) {
        setZoomStatePlayer((prev) => {
          const matched = prev?.dataZoomStates?.find(
            (item) => item.zoomState === dataObject.qualityLevel,
          );
          return {
            ...prev,
            zoomState: dataObject.qualityLevel,
            resolution: matched?.resolution ?? prev?.resolution,
            codec: matched?.codec || null,
          };
        });
      }
      restartQualityCallBack({ qualityLevel: dataObject?.qualityLevel });
    },
    [clearHlsRetryTimers, restartQualityCallBack, setZoomStatePlayer],
  );

  const countRef = useRef(1);

  useEffect(() => {
    if (seekTo > 0 && refVideo.current?.duration > 0) {
      refVideo.current.currentTime = seekTo;
      setVideo((state) => ({
        ...state,
        played: parseFloat(seekTo / refVideo.current.duration),
      }));
    }
  }, [refVideo.current?.duration]);

  useEffect(() => {
    if (type === 'video' && src) {
      let VOLUME = 0.5;
      if (refVideo.current) {
        refVideo.current.addEventListener('error', () => {
          setVideoError("Can't play this video");
          handlePause();
        });
        refVideo.current.setAttribute('src', src);
        refVideo.current.volume = VOLUME;
        const playPromise = refVideo.current.play();
        if (playPromise !== undefined) {
          playPromise.catch((err) => {
            console.warn('Auto-play was prevented:', err);
          });
        }
        setVideo((state) => ({
          ...state,
          src,
          type,
          volume: VOLUME,
          loading: false,
          playing: true,
        }));
      }
    } else if (type === 'streaming' && sourceObject) {
      let VOLUME = 0.5;
      if (!sourceObject?.link && refVideo.current) {
        if ('srcObject' in refVideo.current) {
          refVideo.current.srcObject = sourceObject;
        } else {
          refVideo.current.src = URL.createObjectURL(sourceObject);
        }
      }
      setVideo((state) => ({
        ...state,
        src: sourceObject,
        type,
        loading: false,
        volume: VOLUME,
        playing: true,
      }));
    }
  }, [sourceObject, src, type]);

  useEffect(() => {
    setVideo((state) => ({ ...state, loading }));
  }, [loading]);

  useEffect(() => {
    if (refVideo?.current?.src) {
      handleDropDownTime();
    }
    return () => clearInterval(refInterval.current);
  }, [refVideo?.current?.src]);

  useEffect(() => {
    if (zoomStatePlayer?.dataZoomStates?.length) {
      const dataTemp = [];
      zoomStatePlayer.dataZoomStates.forEach((item) => {
        if (
          !dataTemp?.find(
            (item1) =>
              item1?.resolution === item?.resolution &&
              item1?.zoomState === item?.zoomState,
          )
        ) {
          dataTemp.push(item);
        }
      });
      setZoomStateOption(dataTemp);
    }
  }, [zoomStatePlayer?.dataZoomStates]);

  const handleDropDownTime = () => {
    refInterval.current = setInterval(() => {
      const videoTime = refVideoTotal.current?.currentTimeTotal
        ? refVideoTotal.current?.currentTimeTotal +
        (refVideo.current.currentTime - refVideoTotal.current?.currentTime)
        : refVideo.current.currentTime;
      return setVideo((state) => ({
        ...state,
        played: parseFloat(videoTime / refVideo.current.duration),
      }));
    }, 1000 / video.playbackRate);
  };

  const handlePlay = () => {
    if (!isHlsStreaming) refVideo.current.play();
    return setVideo((state) => ({ ...state, playing: true }));
  };

  const handleRePlay = () => {
    refVideo.current.load();
    refVideo.current.src = video.src;
    refVideo.current.play();
    handleDropDownTime();
    return setVideo((state) => ({ ...state, playing: true, ended: false }));
  };

  const handlePause = () => {
    if (!isHlsStreaming) refVideo.current.pause();
    return setVideo((state) => ({ ...state, playing: false }));
  };

  const handleEnded = () => {
    clearInterval(refInterval.current);
    return setVideo((state) => ({ ...state, ended: true, playing: false }));
  };

  const handleDuration = () => {
    let duration = refVideo.current.duration;
    return setVideo((state) => ({ ...state, duration }));
  };

  const handleSeekMouseDown = (event) => {
    return setVideo((state) => ({ ...state, seeking: true }));
  };

  const handleSeekMouseUp = (event) => {
    setVideo((state) => ({ ...state, seeking: false }));
    const jumpTime =
      (event.nativeEvent.offsetX / progress.current.offsetWidth) *
      video.duration;
    refVideo.current.currentTime = jumpTime;
  };

  const handleSeekChange = (event) => {
    event.persist();
    return setVideo((state) => ({
      ...state,
      played: parseFloat(
        event.nativeEvent.offsetX / progress.current.offsetWidth,
      ),
    }));
  };

  const handleSpeedChange = (playbackRate) => {
    refVideo.current.playbackRate = playbackRate;
    setPlaybackRate(playbackRate);
    return setVideo((state) => ({ ...state, playbackRate }));
  };

  const handleControlsChange = () => {
    onReset();
    return setVideo((state) => ({ ...state, controls: !state.controls }));
  };

  const handleFullscreen = () => {
    const isCurrentlyFullscreen = !!(
      document.fullscreenElement ||
      document.webkitIsFullScreen ||
      document.mozFullScreen ||
      document.msFullscreenElement ||
      document.fullScreen
    );

    if (isCurrentlyFullscreen) {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
      else if (document.webkitCancelFullScreen)
        document.webkitCancelFullScreen();
      else if (document.msExitFullscreen) document.msExitFullscreen();
    } else {
      if (containerRef.current?.requestFullscreen)
        containerRef.current.requestFullscreen();
      else if (containerRef.current?.mozRequestFullScreen)
        containerRef.current.mozRequestFullScreen();
      else if (refVideo.current?.webkitRequestFullScreen)
        refVideo.current.webkitRequestFullScreen();
      else if (containerRef.current?.msRequestFullscreen)
        containerRef.current.msRequestFullscreen();
    }
  };

  const exitHandler = useCallback(() => {
    const isCurrentlyFullscreen = !!(
      document.fullscreenElement ||
      document.webkitIsFullScreen ||
      document.mozFullScreen ||
      document.msFullscreenElement
    );

    if (!isCurrentlyFullscreen) {
      onReset();
      if (type === 'streaming' && fullScreenCallBack) {
        fullScreenCallBack(false);
      }
      setIsFullscreen(false);
      setVideo((state) => ({ ...state, fullscreen: false, controls: false }));
      if (onFullscreenChange) onFullscreenChange(false);
    } else {
      if (type === 'streaming' && fullScreenCallBack) {
        fullScreenCallBack(true);
      }
      setIsFullscreen(true);
      setVideo((state) => ({ ...state, fullscreen: true }));
      if (onFullscreenChange) onFullscreenChange(true);
    }
  }, [fullScreenCallBack, onReset, type, onFullscreenChange]);

  useEffect(() => {
    document.addEventListener('fullscreenchange', exitHandler);
    document.addEventListener('webkitfullscreenchange', exitHandler);
    document.addEventListener('mozfullscreenchange', exitHandler);
    document.addEventListener('MSFullscreenChange', exitHandler);
    return () => {
      document.removeEventListener('fullscreenchange', exitHandler);
      document.removeEventListener('webkitfullscreenchange', exitHandler);
      document.removeEventListener('mozfullscreenchange', exitHandler);
      document.removeEventListener('MSFullscreenChange', exitHandler);
    };
  }, [exitHandler]);

  const handleRotate = useCallback(
    (navigator) => {
      if (rotatable && !rotate) {
        setRotate(navigator);
        return onRotate(navigator);
      }
    },
    [onRotate, rotatable, rotate],
  );

  const handleZoom = useCallback(
    (zoom) => {
      if (rotatable && !rotate) {
        setZooming(zoom);
        return onZoom(zoom);
      }
    },
    [onZoom, rotatable, rotate],
  );

  const handlePin = () => {
    const data = sessionStorage.getItem('pinCamera')?.split(',') || [];
    const dataPin = [...data, serial];
    sessionStorage.setItem('pinCamera', dataPin?.join());
    setPin(dataPin);
  };

  const handleUnPin = () => {
    const data =
      sessionStorage
        .getItem('pinCamera')
        ?.split(',')
        ?.filter((item) => item !== serial) || [];
    sessionStorage.setItem('pinCamera', [...data]?.join());
    setPin([...data]);
  };

  const handleChangeMode = (mode) => {
    const data = pinnedCamerasMode;
    const dataTemp =
      data && JSON.parse(data)
        ? JSON.parse(data)?.filter((item) => item?.serial !== serial)
        : [];
    const dataTempStorage = JSON.stringify([...dataTemp, { serial, mode }]);
    dispatch(setPinnedCamerasMode(dataTempStorage));
    setModeLive(mode);
    onResetQualityStream({ qualityLevel: zoomStatePlayer?.zoomState });
  };

  const handleStreamNotFound = useCallback(() => {
    clearHlsRetryTimers();
    hlsRetryCountRef.current = 0;
    setCountHls(0);
    if (onHlsRemountingChange) onHlsRemountingChange(false);
    dispatch(removeStream(serial));

    if (onStreamNotFound) {
      onStreamNotFound();
      return;
    }

    onResetStream({ qualityLevel: zoomStatePlayer?.zoomState });
  }, [
    clearHlsRetryTimers,
    dispatch,
    onResetStream,
    onStreamNotFound,
    serial,
    zoomStatePlayer?.zoomState,
    onHlsRemountingChange,
  ]);

  const handleError = useCallback(() => {
    if (isRestartHls) {
      beeXLogger.log('HLS already remounting, skip handleError', name);
      return;
    }

    const currentRetry = hlsRetryCountRef.current;
    console.log('START_STREAM_MONITOR - HANDLE ERROR', currentRetry, name);

    if (!navigator.onLine) {
      clearHlsRetryTimers();
      hlsRetryCountRef.current = 0;
      setCountHls(0);
      if (onHlsRemountingChange) onHlsRemountingChange(false);
      dispatch(removeStream(serial));
      onResetStream({ qualityLevel: zoomStatePlayer?.zoomState });
      return;
    }

    if (currentRetry < HLS_PLAYER_REMOUNT_RETRY_MAX) {
      clearHlsRetryTimers();
      const nextRetry = currentRetry + 1;
      hlsRetryCountRef.current = nextRetry;
      setCountHls(nextRetry);
      setIsRestartHls(true);
      setVideo((state) => ({ ...state, loading: true }));
      setPlayedSecs(0);

      if (onHlsRemountingChange) onHlsRemountingChange(true);

      hlsRetryEndTimeoutRef.current = setTimeout(() => {
        setIsRestartHls(false);
        setVideo((state) => ({ ...state, loading: false }));
        if (onHlsRemountingChange) onHlsRemountingChange(false);
      }, HLS_PLAYER_REMOUNT_RETRY_TIMEOUT);

      return;
    }

    clearHlsRetryTimers();
    if (onHlsRemountingChange) onHlsRemountingChange(false);
    dispatch(removeStream(serial));
    onResetStream({ qualityLevel: zoomStatePlayer?.zoomState });
  }, [
    clearHlsRetryTimers,
    dispatch,
    onResetStream,
    serial,
    zoomStatePlayer?.zoomState,
    isRestartHls,
    onHlsRemountingChange,
    name,
  ]);

  const handleProgress = (playedSeconds) => {
    if (playedSeconds - playedSecs >= 2) {
      setPlayedSecs(playedSecs + 1);
    } else {
      setPlayedSecs(playedSeconds);
    }

    if (stablePlayTimerRef.current) clearTimeout(stablePlayTimerRef.current);
    stablePlayTimerRef.current = setTimeout(() => {
      if (hlsRetryCountRef.current > 0) {
        hlsRetryCountRef.current = 0;
        setCountHls(0);
        if (onHlsRemountingChange) onHlsRemountingChange(false);
      }
    }, STABLE_PLAY_THRESHOLD);
  };

  const streamConnectStepProps = {
    step: streamConnectStep,
    currentStep: streamConnectStep,
    stepStates: streamConnectStepStates,
    failedStep: streamConnectErrorStep,
    error: streamConnectError,
    wsHost: streamData?.wsHost,
    protocol: selectedMode || protocol || streamData?.protocol,
    isSuccess:
      typeof streamConnectIsSuccess === 'boolean'
        ? streamConnectIsSuccess
        : Boolean(video?.playing && video?.type === 'streaming'),
  };

  return (
    <div className={`player-component ${gridMode}`} style={{ height: '100%' }}>
      <figure
        ref={containerRef}
        onMouseDown={onMouseDown}
        onWheel={onWheel}
        className="relative"
        style={{
          paddingBottom: isHlsStreaming
            ? '0px'
            : allScreen
              ? '56.25%'
              : `${calcPercentForVideo(windowHeight - 108, windowWidth - 324)}%`,
          backgroundImage:
            !isHlsStreaming || video?.controls || playedSecs > 0
              ? 'unset'
              : `url(${poster})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        {isHlsStreaming && !isRestartHls ? (
          <TransformWrapper>
            <TransformComponent>
              <ReactPlayer
                className="react-player"
                url={sourceObject?.link ?? ''}
                playing={video?.playing}
                pip={false}
                width="100%"
                height="100%"
                ref={(p) => {
                  refVideo.current = p?.getInternalPlayer();
                  if (setRefVideo) setRefVideo(refVideo.current);
                  if (isHlsStreaming) {
                    const hls = p?.getInternalPlayer('hls');
                    if (hls && hlsTrackerRef.current) {
                      hlsTrackerRef.current.attachHls(hls, (stats) => {
                        if (stats && stats.formatted) {
                          setThroughputText(stats.formatted);
                        }
                      });
                    }
                  }
                }}
                playbackRate={playbackRate}
                onProgress={({ playedSeconds }) =>
                  handleProgress(playedSeconds)
                }
                config={{
                  file: {
                    attributes: {
                      disablePictureInPicture: true,
                      controlsList: 'nodownload',
                    },

                    hlsOptions: {
                      maxBufferLength: 30,
                      maxMaxBufferLength: 60,
                      maxBufferSize: 60 * 1000 * 1000,
                      highBufferWatchdogPeriod: 3,
                      nudgeOffset: 0.3,
                      nudgeMaxRetry: 5,
                      fragLoadingRetryDelay: HLS_RETRY_DELAY,
                      fragLoadingMaxRetry: HLS_RETRY_MAX,
                      manifestLoadingRetryDelay: HLS_RETRY_DELAY,
                      manifestLoadingMaxRetry: HLS_RETRY_MAX,
                      levelLoadingRetryDelay: HLS_RETRY_DELAY,
                      levelLoadingMaxRetry: HLS_RETRY_MAX,
                    },
                  },
                }}
                onError={(error, value) => {
                  if (!navigator.onLine) {
                    beeXLogger.error(
                      'HLS offline detected, forcing stream recreate',
                      name,
                    );
                    handleError();
                    return;
                  }

                  if (error && value && value?.fatal === false) {
                    beeXLogger.error(
                      'Non-fatal media error, skipping retry:',
                      name,
                      error,
                      value,
                    );
                    return;
                  }

                  if (isStreamNotFoundError(error, value)) {
                    beeXLogger.error(
                      'HLS stream not found, recreating with retry:1',
                      name,
                      error,
                      value,
                    );
                    handleStreamNotFound();
                    return;
                  }

                  if (value?.type === 'networkError') {
                    dispatch(removeStream(serial));
                    handleError();
                    return;
                  }

                  if (value?.fatal === true) {
                    beeXLogger.error(
                      'HLS fatal error',
                      name,
                      value?.type,
                      error,
                    );
                    handleError();
                    return;
                  }

                  if (onError) {
                    onError(error, value);
                  }
                }}
                onPlay={onPlay}
              />
            </TransformComponent>
          </TransformWrapper>
        ) : (
          <video
            id={`video-live-stream-${key}`}
            onDoubleClick={() => handleFullscreen()}
            poster={poster}
            ref={(p) => {
              refVideo.current = p;
              if (setRefVideo) setRefVideo(refVideo.current);
            }}
            className="player-video"
            onDurationChange={handleDuration}
            onEnded={handleEnded}
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              transform: `translate(${translateX}px, ${translateY}px) scale(${scale})`,
            }}
            autoPlay
            onPlay={onPlay}
          />
        )}

        {(video && video.loading) || checkTransferZoomState ? (
          type === 'streaming' ? (
            <>
              {type === 'streaming' && (
                <div
                  className={
                    pin?.find((item) => item === serial) || isPinAll
                      ? 'top-player-component no-select pinCam'
                      : 'top-player-component no-select'
                  }
                >
                  <div className="stream_name">
                    <div className="status">{name}</div>
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                    >
                      {/* <StreamConnectStep {...streamConnectStepProps} /> */}
                      {pin?.find((item) => item === serial) || isPinAll ? (
                        <PushpinFilled
                          className="pin"
                          onClick={() => handleUnPin()}
                        />
                      ) : (
                        <PushpinOutlined
                          className="pin"
                          onClick={() => handlePin()}
                        />
                      )}
                    </div>
                  </div>
                  {status && status !== 'live' && (
                    <div className="stream_state">
                      <div className="status">{status}</div>
                    </div>
                  )}
                </div>
              )}
              <div
                className={`bottom-player-component no-select ${isFullScreen ? 'in-fullscreen' : 'not-in-fullscreen'}`}
              >
                <div className="bottom-player-control-left">
                  <div>
                    <button
                      className="play"
                      style={{ padding: '8px 6px 1px 6px' }}
                    >
                      <StreamConnectStep {...streamConnectStepProps}>
                        <LoadingOutlined style={{ fontSize: '18px' }} />
                      </StreamConnectStep>
                    </button>
                  </div>
                  <button className="stream">
                    <img src={StreamIcon} alt="" />
                  </button>
                  <div>
                    <button
                      onClick={() => {
                        onResetStreamLoading({
                          qualityLevel: zoomStatePlayer?.zoomState,
                        });
                      }}
                      className="reset-stream"
                    >
                      <img src={ResetIcon} alt="" />
                    </button>
                  </div>
                  <button className="time">
                    <DurationComponent seconds={0} />
                  </button>
                </div>
                <div className="stream-progress" />
                <div className="bottom-player-control-right">
                  <div className="speed">
                    <button className="resolution">
                      {`${zoomStatePlayer?.resolution || 720}p` ?? ''}
                    </button>
                    <div className="speeds">
                      {zoomStateOption?.map((q, index) => (
                        <Fragment key={`${q?.zoomState}_${index}`}>
                          <button
                            className={ClassNames({
                              selected:
                                q?.zoomState === zoomStatePlayer?.zoomState,
                            })}
                            key={q?.zoomState}
                            onClick={() =>
                              onResetStreamLoading({
                                qualityLevel: q?.zoomState,
                              })
                            }
                          >
                            {`${q?.resolution || 720}p` ?? ''}
                          </button>
                          <br />
                        </Fragment>
                      ))}
                    </div>
                  </div>
                  <div className="speed">
                    <button className="resolution">
                      {StreamOptions[selectedMode]}
                    </button>
                    <div className="speeds" style={{ width: '82px' }}>
                      {modes?.map((mode, index) => (
                        <Fragment key={`${mode}_${index}`}>
                          <button
                            className={ClassNames({
                              selected: mode === selectedMode,
                            })}
                            style={{ padding: '4px 10px' }}
                            key={mode}
                            onClick={() => handleChangeMode(mode)}
                          >
                            {`${StreamOptions[mode]}` ?? ''}
                          </button>
                          <br />
                        </Fragment>
                      ))}
                    </div>
                  </div>
                  {!!isFullScreen && (
                    <div className="control">
                      <button
                        onClick={handleControlsChange}
                        className="settings"
                      >
                        <img
                          src={
                            rotatable
                              ? video.controls
                                ? ControlIconOn
                                : ControlIconOff
                              : video.controls
                                ? MoveIconOn
                                : MoveIconOff
                          }
                          alt=""
                        />
                      </button>
                    </div>
                  )}
                  <div className="expand">
                    <button
                      onClick={() => handleFullscreen()}
                      className="fullscreen"
                    >
                      {!!isFullScreen ? (
                        <img src={ExitFullscreenIcon} alt="" />
                      ) : (
                        <img src={FullscreenIcon} alt="" />
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="loading">
              <SpinnerComponent />
            </div>
          )
        ) : (
          !!video.src && (
            <Fragment>
              {video && video.controls && rotatable && (
                <Fragment>
                  <div className="controls-video">
                    <div className="move-buttons">
                      <div />
                      <button onClick={() => handleRotate('up')}>
                        <img
                          src={
                            rotate && rotate === 'up'
                              ? ArrowTopOnIcon
                              : ArrowTopOffIcon
                          }
                          alt="up_button"
                        />
                      </button>
                      <div />
                      <button onClick={() => handleRotate('left')}>
                        <img
                          src={
                            rotate && rotate === 'left'
                              ? ArrowLeftOnIcon
                              : ArrowLeftOffIcon
                          }
                          alt="left_button"
                        />
                      </button>
                      <button onClick={() => onReset()}>
                        <img src={CenterControlIcon} alt="" />
                      </button>
                      <button onClick={() => handleRotate('right')}>
                        <img
                          src={
                            rotate && rotate === 'right'
                              ? ArrowRightOnIcon
                              : ArrowRightOffIcon
                          }
                          alt="right_button"
                        />
                      </button>
                      <div />
                      <button onClick={() => handleRotate('down')}>
                        <img
                          src={
                            rotate && rotate === 'down'
                              ? ArrowBottomOnIcon
                              : ArrowBottomOffIcon
                          }
                          alt="down_button"
                        />
                      </button>
                      <div />
                    </div>
                  </div>
                  <div className="zoom-buttons">
                    <button onClick={() => handleZoom('zoom+')}>
                      <img
                        src={
                          zooming && zooming === 'zoom+'
                            ? ZoomInOnIcon
                            : ZoomInOffIcon
                        }
                        alt="zoom in"
                      />
                    </button>
                    <button onClick={() => handleZoom('zoom-')}>
                      <img
                        src={
                          zooming && zooming === 'zoom-'
                            ? ZoomOutOnIcon
                            : ZoomOutOffIcon
                        }
                        alt="zoom out"
                      />
                    </button>
                  </div>
                </Fragment>
              )}

              {type === 'streaming' && (
                <div
                  className={
                    pin?.find((item) => item === serial) || isPinAll
                      ? 'top-player-component no-select pinCam'
                      : 'top-player-component no-select'
                  }
                >
                  <div className="stream_name">
                    <div className="status">{name}</div>
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                    >
                      {/* <StreamConnectStep {...streamConnectStepProps} /> */}
                      {pin?.find((item) => item === serial) || isPinAll ? (
                        <PushpinFilled
                          className="pin"
                          onClick={() => handleUnPin()}
                        />
                      ) : (
                        <PushpinOutlined
                          className="pin"
                          onClick={() => handlePin()}
                        />
                      )}
                    </div>
                  </div>
                  {status && status !== 'live' && (
                    <div className="stream_state">
                      <div className="status">{status}</div>
                    </div>
                  )}
                </div>
              )}

              {/* Bottom controls */}
              <div
                className={`bottom-player-component no-select ${isFullScreen ? 'in-fullscreen' : 'not-in-fullscreen'}`}
              >
                <div className="bottom-player-control-left">
                  <>
                    {video.playing ? (
                      <StreamConnectStep {...streamConnectStepProps}>
                        <div>
                          <button
                            onClick={() => handlePause()}
                            className="play"
                          >
                            <img src={PauseIcon} alt="" />
                          </button>
                        </div>
                      </StreamConnectStep>
                    ) : video.ended ? (
                      <div>
                        <button onClick={() => handleRePlay()} className="play">
                          <img src={ReplayIcon} alt="" />
                        </button>
                      </div>
                    ) : (
                      <div>
                        <button onClick={() => handlePlay()} className="play">
                          <img src={PlayArrowIcon} alt="" />
                        </button>
                      </div>
                    )}
                  </>
                  {video?.type === 'streaming' && (
                    <>
                      <button className="stream">
                        <img src={StreamIcon} alt="" />
                      </button>
                      <div>
                        <button
                          onClick={() => {
                            onResetStream({
                              qualityLevel: zoomStatePlayer?.zoomState,
                            });
                          }}
                          className="reset-stream"
                        >
                          <img src={ResetIcon} alt="" />
                        </button>
                      </div>
                      <div>
                        <button className="time">
                          <DurationComponent
                            seconds={
                              isHlsStreaming
                                ? playedSecs
                                : refVideo.current?.currentTime
                            }
                          />
                        </button>
                      </div>
                    </>
                  )}
                </div>

                {video.type === 'video' && (
                  <Fragment>
                    <div
                      onClick={handleSeekChange}
                      onMouseUp={handleSeekMouseUp}
                      onMouseDown={handleSeekMouseDown}
                      ref={progress}
                      className="progress"
                    >
                      <div
                        className="progress-filled"
                        style={{ flexBasis: `${video.played * 100}%` }}
                      />
                      <div
                        className="point"
                        style={{ marginLeft: `${video.played * 100}%` }}
                      >
                        <div className="timer">
                          <button className="timing">
                            <DurationComponent
                              seconds={
                                video &&
                                Math.round(video.played * video.duration)
                              }
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div>
                      <button className="time">
                        <DurationComponent seconds={video.duration} />
                      </button>
                    </div>
                    <div className="speed">
                      <button>
                        {
                          speeds.filter(
                            (speed) => speed.value === video.playbackRate,
                          )[0].title
                        }
                      </button>
                      <div className="speeds">
                        {speeds.map((q) => (
                          <button
                            className={ClassNames({
                              selected: q.value === video.playbackRate,
                            })}
                            key={q.value}
                            onClick={() => handleSpeedChange(q.value)}
                          >
                            {q.title}
                          </button>
                        ))}
                      </div>
                    </div>
                    {currentCodec && (
                      <div className="codec-tag">
                        <span className="resolution" style={{ cursor: 'default' }}>
                          {currentCodec}
                        </span>
                      </div>
                    )}
                    {/* {throughputText && (
                      <div className="throughput-tag">
                        <span
                          className="resolution"
                          title="Received Throughput (Tốc độ nhận thực tế)"
                          style={{ cursor: 'default' }}
                        >
                          {throughputText}
                        </span>
                      </div>
                    )} */}
                    {permission &&
                      permission.find((item) => item === 'download') && (
                        <div className="download">
                          {isDownloading ? (
                            <button>
                              <StreamConnectStep {...streamConnectStepProps}>
                                <LoadingOutlined style={{ fontSize: '18px' }} />
                              </StreamConnectStep>
                            </button>
                          ) : (
                            <button
                              onClick={() => {
                                setIsDownloading(true);
                                downloadFile({
                                  url: src,
                                  fileName: JSON.parse(logContent).cameraName,
                                  isSaveAs: JSON.parse(logContent).isSaveAs,
                                  onFetched: () => {
                                    setIsDownloading(false);
                                  },
                                });
                                handleReportActionLog(logContent, logSerial);
                              }}
                            >
                              <img src={DownloadIcon} alt="" />
                            </button>
                          )}
                        </div>
                      )}
                  </Fragment>
                )}

                {video.type === 'streaming' && (
                  <Fragment>
                    <div className="stream-progress" />
                    {!isHlsStreaming && (
                      <div className="download">
                        <button onClick={onDownloadDirectClick}>
                          <CameraOutlined style={{ fontSize: '20px' }} />
                        </button>
                      </div>
                    )}
                    <div className="speed">
                      <button className="resolution">
                        {`${zoomStatePlayer?.resolution || 720}p` ?? ''}
                      </button>
                      {zoomStateOption && zoomStateOption.length > 1 && (
                        <div className="speeds">
                          {zoomStateOption.map((q) => (
                            <button
                              className={ClassNames({
                                selected:
                                  q?.zoomState === zoomStatePlayer?.zoomState,
                              })}
                              key={q?.zoomState}
                              onClick={() =>
                                onResetQualityStream({
                                  qualityLevel: q?.zoomState,
                                })
                              }
                            >
                              {`${q?.resolution || 720}p` ?? ''}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                    {currentCodec && (
                      <div className="codec-tag">
                        <span className="resolution" style={{ cursor: 'default' }}>
                          {currentCodec}
                        </span>
                      </div>
                    )}
                    {/* {throughputText && (
                      <div className="throughput-tag">
                        <span
                          className="resolution"
                          title="Received Throughput (Tốc độ nhận thực tế)"
                          style={{ cursor: 'default' }}
                        >
                          {throughputText}
                        </span>
                      </div>
                    )} */}
                    <div className="speed">
                      <button className="resolution">
                        {StreamOptions[selectedMode]}
                      </button>
                      {modes && modes.length > 1 && (
                        <div className="speeds" style={{ width: '82px' }}>
                          {modes.map((mode) => (
                            <button
                              className={ClassNames({
                                selected: mode === selectedMode,
                              })}
                              style={{ padding: '4px 10px' }}
                              key={mode}
                              onClick={() => handleChangeMode(mode)}
                            >
                              {`${StreamOptions[mode]}` ?? ''}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </Fragment>
                )}

                <div className="bottom-player-control-right">
                  {!!isFullScreen && (
                    <div className="control">
                      <button
                        onClick={handleControlsChange}
                        className="settings"
                      >
                        <img
                          src={
                            rotatable
                              ? video.controls
                                ? ControlIconOn
                                : ControlIconOff
                              : video.controls
                                ? MoveIconOn
                                : MoveIconOff
                          }
                          alt=""
                        />
                      </button>
                    </div>
                  )}
                  <div className="expand">
                    <button
                      onClick={() => handleFullscreen()}
                      className="fullscreen"
                    >
                      {isFullScreen ? (
                        <img src={ExitFullscreenIcon} alt="" />
                      ) : (
                        <img src={FullscreenIcon} alt="" />
                      )}
                    </button>
                  </div>
                </div>
                <canvas crossOrigin="anonymous" ref={canvasRef} hidden />
              </div>
            </Fragment>
          )
        )}

        {!!(dataUser?.enableWatermark && video.playing) && (
          <div className="watermark-container">
            {[...Array(8)].map((item) => (
              <p key={item} style={{ transform: 'rotate(330deg)' }}>
                {dataUser.phoneNumber}
              </p>
            ))}
          </div>
        )}
      </figure>

      {videoError && <div className="video-error">{videoError}</div>}
    </div>
  );
};

export default PlayerComponent;
